import { createElement } from 'react';
import cn from 'classnames';
import styles from './Subtitle.module.scss';

const Subtitle = ({ text, className, htmlFor }) => {
  const props = { className: cn(styles.root, className) };

  if (Boolean(htmlFor)) props.htmlFor = htmlFor;

  return createElement(Boolean(htmlFor) ? 'label' : 'p', props, text);
};

export default Subtitle;
